// extracted by mini-css-extract-plugin
module.exports = {"cls1":"styles-ProjectName-module--cls1--K2Xpy","cls2":"styles-ProjectName-module--cls2--atuKM styles-ProjectName-module--cls1--K2Xpy"};